import { UAParser } from 'ua-parser-js';
import { hasPropertyValues } from 'app/infrastructure/push/hasPropertyValues';
import { ConfigurationAccess } from 'app/area/user-profile/my-notifications/types';
import { firebaseConfig, webPushCertificate } from 'app/infrastructure/push/configuration-data';

const { b64PublicKey } = webPushCertificate;

const parser = new UAParser();
const browser = parser.getBrowser();
const validBrowser = browser && browser.name !== 'Safari' && browser.name !== '[Mobile] Safari';

export const configurationAccess: ConfigurationAccess = {
  push: validBrowser && firebaseConfig && b64PublicKey && hasPropertyValues(firebaseConfig, ['messagingSenderId'])
};
